module.exports = __webpack_public_path__ + "img/frame (138).fb7d5cc0.jpg";